import * as React from 'react';
import _, { orderBy } from 'lodash';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import { useParameterizedQuery } from 'react-fetching-library';


export const AutocompleteImpl = props => {
  const { sx, displayName, action, fieldName, formik, size, multiple, defaultValue, resortId = null, disablePortal = true } = props;
  const { query } = useParameterizedQuery(action);
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;

  React.useEffect(() => {

    if (!loading) {
      return undefined;
    }

    (async () => {
      const { payload, error, loading: qLoading } = await query(null, 'options');

      if (!error && !qLoading) {
        if (resortId != null) {
          setOptions(payload.actions.GET[`${fieldName}_resort`].choices[resortId]);
        } else {
          setOptions(payload.actions.GET[fieldName].choices);
        }
      }
    })();

  }, [loading]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  const handleChange = item => {
    console.log(item);
    formik.setFieldValue(fieldName, item);
  };

  return (
    <Autocomplete
      id="asynchronous-demo"
      sx={{ width: '60%', maxWidth: '1200px', ...sx }}
      open={open}
      disablePortal={disablePortal}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      size={size || 'small'}
      multiple={multiple || false}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={option => _.isObject(option) && !_.isArray(option) ? option.label : displayName}
      defaultValue={multiple ? defaultValue : { label: displayName, value: formik.values[fieldName] }}
      onChange={(e, item) => handleChange(item)}
      options={options}
      loading={loading}
      value={formik.values[fieldName]}
      renderInput={params => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            )
          }}
          SelectProps={{
            MenuProps: {
              style: { zIndex: 35001 }
            }
          }}
        />
      )}
    />
  );
};
